// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6781":"ba90bc5ca18111fa","8855":"3af225c7c090ac68"}[chunkId] + ".js";
};